module.exports = __webpack_public_path__ + "static/media/view_videos.b213cd41.png";